"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateStyles = void 0;
const masonryGrid_1 = require("./masonryGrid");
const translateStyles = () => {
    let width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    let translateElement = document.createElement('div');
    translateElement.setAttribute('id', 'google_translate_element');
    let existingELement = document.getElementById('google_translate_element');
    if (!existingELement) {
        if (width <= 768) {
            document.querySelector('[data-translate="mobile"]').append(translateElement);
        }
        else {
            document.querySelector('[data-translate="desktop"]').append(translateElement);
        }
    }
    let googleTranslate = document.querySelector('.goog-te-menu-frame');
    if (googleTranslate) {
        const iWindow = googleTranslate.contentWindow;
        const iDocument = iWindow.document;
        let googleTranslateBody = iDocument.querySelector('head');
        let styles = iDocument.createElement('style');
        styles.textContent = `.goog-te-menu-frame {box-shadow: 1px 0 8px rgba(0, 0, 0, 0.25), 4px 4px 8px rgba(0, 0, 0, 0.25) !important;} `;
        styles.textContent += `.goog-te-menu2 {border: none !important;} `;
        styles.textContent += `.goog-te-menu2 * {font-family: 'Arial', sans-serif;} `;
        styles.textContent += `.goog-te-menu2 tr {display: flex; flex-direction: column;} `;
        styles.textContent += `.goog-te-menu2 .goog-te-menu2-colpad {display: none;} `;
        styles.textContent += `.goog-te-menu2-item div, goog-te-menu2-item:link div, goog-te-menu2-item:visited div, goog-te-menu2-item:active div {background: none; color: #020F42 !important; transition: all 0.2s ease-in-out;} `;
        styles.textContent += `.goog-te-menu2-item:hover div {background: none; color: #232D55 !important;}`;
        googleTranslateBody.append(styles);
        (0, masonryGrid_1.masonryGrid)();
    }
    else {
        setTimeout(exports.translateStyles, 200);
    }
    document.addEventListener("DOMContentLoaded", exports.translateStyles);
    window.addEventListener("resize", exports.translateStyles);
};
exports.translateStyles = translateStyles;
